// extracted by mini-css-extract-plugin
export default {"statueContainer":"Statute_statueContainer__g6BO-","statueContent":"Statute_statueContent__WBusm","description":"Statute_description__ODI31"};